import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SaveTempService {

	private currentStorage: Storage = localStorage;
	static prefix: string = "save_temp_";

	constructor() { }

	public getItem(key: string) {
		return JSON.parse(this.currentStorage.getItem(SaveTempService.prefix + key));
	}

	public setItem(key: string, data: any): void {
		this.currentStorage.setItem(SaveTempService.prefix + key, JSON.stringify(data));
	}

	public empty() {
		const toRemove = [];
		let key;

		for (let i = 0; i < this.currentStorage.length; i++) {
			key = this.currentStorage.key(i);

			if (key && key.startsWith(SaveTempService.prefix)) {
				toRemove.push(key);
			}
		}

		for (let key of toRemove) {
			this.currentStorage.removeItem(key);
		}
	}
}